class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections && parsedState.sections[section.id];

      if (!target || !html) return;

      target.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });

    this.animateCartIcon();

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : '';
  }

  animateCartIcon() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    const submitButton = document.querySelector('.product-form__submit[aria-disabled="true"]');

    if (!cartIcon || !submitButton) return;

    const startRect = submitButton.getBoundingClientRect();
    const endRect = cartIcon.getBoundingClientRect();
    const dot = document.createElement('span');
    const dotSize = 14;

    dot.className = 'bigshocked-cart-fly-dot';
    dot.style.left = `${startRect.left + startRect.width / 2 - dotSize / 2}px`;
    dot.style.top = `${startRect.top + startRect.height / 2 - dotSize / 2}px`;
    document.body.appendChild(dot);

    const translateX = endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    const translateY = endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);

    dot.animate(
      [
        { transform: 'translate3d(0, 0, 0) scale(1)', opacity: 1 },
        { transform: `translate3d(${translateX * 0.45}px, ${translateY - 80}px, 0) scale(0.92)`, opacity: 1, offset: 0.55 },
        { transform: `translate3d(${translateX}px, ${translateY}px, 0) scale(0.35)`, opacity: 0.15 },
      ],
      {
        duration: 720,
        easing: 'cubic-bezier(.22,.75,.25,1)',
        fill: 'forwards',
      }
    ).onfinish = () => {
      dot.remove();
      cartIcon.classList.remove('bigshocked-cart-icon-pop');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('bigshocked-cart-icon-pop');
    };
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
